import React, {useEffect, useRef, useState} from 'react'
import {Display} from "../../../CRM/organism/Main/styles";
import {CustomerCommercialFilter} from "./CustomerCommercialFilter";
import {CustomerCommercialTable} from "./CustomerCommercialTable";
import styled from "styled-components";
import {ApplicationOneStep} from "./blocks/ApplicationOneStep";
import {ApplicationTwoStep} from "./blocks/ApplicationTwoStep";
import {ApplicationThreeStep} from "./blocks/ApplicationThreeStep";
import {ApplicationFourthStep} from "./blocks/ApplicationFourthStep";
import {useAdvertiserADList} from "../../hooks/Advertiser/CustomerCommercial/GetAdvertiserADList";
import {useAdvertiserADInfo} from "../../hooks/Advertiser/CustomerCommercial/GetAdvertiserADInfo";
import {useRecoilState} from "recoil";
import {adIdAtom} from "../../../utils/recoil/Customercommercial";

export const CustomerCommercial: React.FC = () => {
    // 필터링 관련
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [status, setStatus] = useState(0); // 1: 승인대기 | 2: 승인완료 | 3: 거절 | 4: 재요청 | 5: 진행중 | 6: 광고종료
    const [order, setOrder] = useState<'latest' | 'oldest'>('latest');

    // 유틸리티
    const [isOneStepModal, setIsOneStepModal] = useState(false);
    const [isTwoStepModal, setIsTwoStepModal] = useState(false);
    const [isThreeStepModal, setIsThreeStepModal] = useState(false);
    const [isFourthStepModal, setIsFourthStepModal] = useState(false);

    // 첫번째 단계 상태값
    const [title, setTitle] = useState('');
    const [startedAt, setStartedAt] = useState('');
    const [endedAt, setEndedAt] = useState('');
    const [itemId, setItemId] = useState<any>(null);
    const [fileList, setFileList] = useState<any>([]);
    const [days, setDays] = useState(0);
    const [adIdValue, setAdIdValue] = useRecoilState(adIdAtom);
    const [totalPrice, setTotalPrice] = useState<any>(0);

    // 두번째 단계 상태값
    const [agentIds, setAgentIds] = useState<number[]>([]);

    // 유틸리티
    const [isSelectItem, setIsSelectItem] = useState(false);
    const [selectedRows, setSelectedRows] = useState<number[]>([]);
    const [isAllChecked, setIsAllChecked] = useState(false);

    // 데이터 조회
    const {
        advertiserADList,
        mutateAdvertiserADList,
        total,
        isLoading
    } = useAdvertiserADList(page, pageSize, status, order);
    const {advertiserADInfo, mutateAdvertiserADInfo} = useAdvertiserADInfo(adIdValue);

    // 모달 초기화가 이미 되었는지 표시 (열릴 때 1회만 동기화)
    const initOnceRef = useRef(false);

    // 문자열/배열 파싱 헬퍼
    const parseFromInfo = (info: any) => {
        const nextTitle: string = info?.title ?? "";
        const nextItemId = info?.itemId ?? null;

        const period: string = info?.period ?? "";
        const dayMatch = period.match(/^(\d+)일/);
        const nextDays = dayMatch ? Number(dayMatch[1]) : 0;

        const dateMatch = period.match(/(\d{4}-\d{2}-\d{2})~(\d{4}-\d{2}-\d{2})/);
        const nextStartedAt = dateMatch?.[1] ?? "";
        const nextEndedAt = dateMatch?.[2] ?? "";

        const nextAgentIds: number[] =
            (info?.list ?? [])
                .map((v: any) => Number(v?.agentId))
                .filter((n: number) => Number.isFinite(n));

        return {
            nextTitle,
            nextItemId,
            nextDays,
            nextStartedAt,
            nextEndedAt,
            nextAgentIds,
        };
    };

    // 모달 열릴 때만 1회 동기화
    useEffect(() => {
        // 모달이 열려있고, 데이터가 있고, 아직 초기화 안했을 때만
        if (!isOneStepModal || !advertiserADInfo || initOnceRef.current) return;

        console.log('//advertiserADInfo', advertiserADInfo)
        if (advertiserADInfo?.fileList?.length === 0) return;
        const {
            nextTitle,
            nextItemId,
            nextDays,
            nextStartedAt,
            nextEndedAt,
            nextAgentIds,
        } = parseFromInfo(advertiserADInfo);
        // 기존 값과 다를 때만 setState
        setTitle((prev) => (prev !== nextTitle ? nextTitle : prev));
        setItemId((prev) => (prev !== nextItemId ? nextItemId : prev));
        setDays((prev) => (prev !== nextDays ? nextDays : prev));
        setStartedAt((prev) => (prev !== nextStartedAt ? nextStartedAt : prev));
        setEndedAt((prev) => (prev !== nextEndedAt ? nextEndedAt : prev));
        setAgentIds((prev) => {
            const same =
                prev.length === nextAgentIds.length &&
                prev.every((v, i) => v === nextAgentIds[i]);
            return same ? prev : nextAgentIds;
        });

        initOnceRef.current = true; // ✅ 1회만
    }, [isOneStepModal, advertiserADInfo]);

    const RegistCommercial = () => {
        setIsOneStepModal(true);

        // 신규신청 초기화
        setTitle('');
        setItemId('');
        setDays(0);
        setStartedAt('');
        setEndedAt('');
        setAgentIds([]);
        setAdIdValue(null);

        // 다음 오픈 시 다시 1회 초기화되도록 플래그 리셋
        initOnceRef.current = false;
    };

    // 광고 상세 편집을 위해 행 클릭 시 호출한다고 가정: setAdIdValue(...) 후 모달 오픈
    // 모달을 닫을 때도 initOnceRef 리셋이 필요하다면, 모달 컴포넌트의 onClose에서 false로 돌려줘도 OK.

    console.log('//data', days, startedAt, endedAt);

    return (
        <>
            <Display>
                <RegistSection>
                    <OutputFileButton onClick={RegistCommercial}>광고신청</OutputFileButton>
                </RegistSection>

                <CustomerCommercialFilter
                    setIsSelectItem={setIsSelectItem}
                    isSelectItem={isSelectItem}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    setStatus={setStatus}
                    setOrder={setOrder}
                    order={order}
                    mutateAdvertiserADList={mutateAdvertiserADList}
                />

                <CustomerCommercialTable
                    setIsSelectItem={setIsSelectItem}
                    isSelectItem={isSelectItem}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    isAllChecked={isAllChecked}
                    setIsAllChecked={setIsAllChecked}
                    advertiserADList={advertiserADList}
                    mutateAdvertiserADList={mutateAdvertiserADList}
                    setAdIdValue={(id: any, openOneStep?: boolean) => {
                        setAdIdValue(id);
                        if (openOneStep) {
                            setIsOneStepModal(true);
                        }
                        initOnceRef.current = false; // 편집 진입 시 1회만 초기화
                    }}
                    setIsOneStepModal={setIsOneStepModal}
                    advertiserADInfo={advertiserADInfo}
                    setIsFourthStepModal={setIsFourthStepModal}
                    setIsThreeStepModal={setIsThreeStepModal}
                    total={total}
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    isLoading={isLoading}
                />
            </Display>

            {isOneStepModal && (
                <ApplicationOneStep
                    setIsOneStepModal={(v: boolean) => {
                        setIsOneStepModal(v);
                        if (!v) initOnceRef.current = false; // 닫을 때 리셋
                    }}
                    setIsTwoStepModal={setIsTwoStepModal}
                    title={title}
                    setTitle={setTitle}
                    startedAt={startedAt}
                    setStartedAt={setStartedAt}
                    endedAt={endedAt}
                    setEndedAt={setEndedAt}
                    itemId={itemId}
                    setItemId={setItemId}
                    fileList={fileList}
                    setFileList={setFileList}
                    days={days}
                    setDays={setDays}
                    setAdIdValue={setAdIdValue}
                    setTotalPrice={setTotalPrice}
                    mutateAdvertiserADList={mutateAdvertiserADList}
                    totalPrice={totalPrice}
                    adIdValue={adIdValue}
                />
            )}

            {isTwoStepModal && (
                <ApplicationTwoStep
                    setIsTwoStepModal={setIsTwoStepModal}
                    setIsOneStepModal={setIsOneStepModal}
                    setIsThreeStepModal={setIsThreeStepModal}
                    adIdValue={adIdValue}
                    totalPrice={totalPrice}
                    days={days}
                    startedAt={startedAt}
                    endedAt={endedAt}
                    mutateAdvertiserADList={mutateAdvertiserADList}
                    agentIds={agentIds}
                    setAgentIds={setAgentIds}
                    mutateAdvertiserADInfo={mutateAdvertiserADInfo}
                />
            )}

            {isThreeStepModal && (
                <ApplicationThreeStep
                    setIsTwoStepModal={setIsTwoStepModal}
                    setIsThreeStepModal={setIsThreeStepModal}
                    setIsFourthStepModal={setIsFourthStepModal}
                    advertiserADInfo={advertiserADInfo}
                    adIdValue={adIdValue}
                    mutateAdvertiserADList={mutateAdvertiserADList}
                />
            )}

            {isFourthStepModal && (
                <ApplicationFourthStep
                    setIsFourthStepModal={setIsFourthStepModal}
                    advertiserADInfo={advertiserADInfo}
                />
            )}
        </>
    )
}

const RegistSection = styled.div`
    display: flex;
    justify-content: flex-end;
`;

const OutputFileButton = styled.div`
    background-color: #530DAD;
    box-shadow: 0px 0px 10px 0px #0000000D;
    width: 140px;
    height: 42px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    cursor: pointer;

    font-weight: 600;
    font-size: 15px;
    line-height: 17.9px;
    font-family: Pretendard, sans-serif;
`;
